import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import FilledInBy from './common/FilledInBy';
import RequiredToggle from './common/RequiredToggle';
import Title from './common/Title';

export default function SentimentModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	optional?: boolean | null;
	item: graphql.EvaluationSentimentItem;
	onChange: (
		item: graphql.EvaluationSentimentItem,
		fillInBy: graphql.EvaluationFillInBy,
		optional: boolean,
	) => void;
}) {
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: {
			fillInBy: props.fillInBy,
			title: props.item.title,
			optional: props.optional ?? false,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (!formik.values.title.find(({ text }) => text.length > 0)) {
			return;
		}

		props.onChange(
			{
				...props.item,
				title: formik.values.title,
			},
			formik.values.fillInBy,
			formik.values.optional,
		);
	}, [formik.values.title, formik.values.fillInBy, formik.values.optional]);

	return (
		<FormikProvider value={formik}>
			<Flex p={3} flexDirection="column">
				<Title label={t('common.settings.evaluationForms.sentiment.question.label')} />
				<FilledInBy />
				<RequiredToggle />
			</Flex>
		</FormikProvider>
	);
}
